export default new (class Buy {
    constructor() {
        this.buy = 'buy';
        this.buyContent = 'buy-content';
        this.buyBtn = 'buy-btn';
        this.buyBtnClose = 'buy-close';
        document.addEventListener("DOMContentLoaded", () => {
            this.initHandler()
        })
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.querySelectorAll(`.${this.buyBtn}`).forEach((item) => {
            if (item.classList.contains('_inited')) return;
            item.addEventListener('mouseover', (e) => {
                item.querySelector(`.${this.buyContent}`).classList.add('open')
            });
            item.classList.add('_inited')
        });
        document.querySelectorAll(`.${this.buy}`).forEach((item) => {
            if (item.classList.contains('_inited')) return;
            item.addEventListener('mouseleave', (e) => {
                item.querySelector(`.${this.buyContent}`).classList.remove('open')
            });
            item.classList.add('_inited')
        });
        document.querySelectorAll(`.${this.buyBtnClose}`).forEach((item) => {
            if (item.classList.contains('_inited')) return;
            item.addEventListener('click', (e) => {
                item.closest(`.${this.buy}`).querySelector(`.${this.buyContent}`).classList.remove('open')
            });
            item.classList.add('_inited')
        });
    }
})()
